import { Middleware } from '@nuxt/types'
import loginUser from '@/utils/login-user'

const authenticated: Middleware = async ({ store, route, redirect }) => {
  if (process.server) return
  await loginUser(store, route.path, redirect)
}

export default authenticated
